import { NewBlossomComponent } from "components/flexFramework/domain/NewBlossomComponent";
import { FlexModuleModelStore } from "src/stores/FlexModuleModelStore";

export class BlossomComponentTree {
  public tree: NewBlossomComponent[];

  constructor(tree?: NewBlossomComponent[]) {
    this.tree = tree || [];
  }

  /**
   * hydrates serialized BlossomComponentTree and it's BlossomComponents, adding methods and wiring to FlexModuleModelStore
   * @param flexModuleModelStore
   * @return BlossomComponentTree
   */
  public hydrateTree = (flexModuleModelStore: FlexModuleModelStore): BlossomComponentTree => {
    const hydrateBlossomComponents = (components: NewBlossomComponent[]): NewBlossomComponent[] => {
      const result: NewBlossomComponent[] = [];
      components.forEach((component) => {
        const children = component.children ? hydrateBlossomComponents(component.children) : [];

        result.push(
          new NewBlossomComponent({
            componentData: {
              id: component.id,
              name: component.name,
              fmId: component.fmId,
              fmTitleId: component.fmTitleId,
              view: component.view,
              scene: component.scene,
              children,
            },
            flexModuleModelStore,
          })
        );
      });

      return result;
    };

    this.tree = hydrateBlossomComponents(this.tree);

    return this;
  };

  /**
   * returns first BlossomComponent in tree with matching fmId, undefined if not found
   * @returns NewBlossomComponent | undefined
   * @memberof BlossomComponentTree
   */
  public findBlossomComponentByFmId = (fmId?: number): NewBlossomComponent | undefined => {
    const result = this.findBlossomComponentInTree((component: NewBlossomComponent) => component.fmId === fmId);

    return result;
  };

  /**
   * returns first match in BlossomComponentTree which satisfies the provided test, iterating from the top of the tree downward
   * @param {function} test
   * @returns NewBlossomComponent | undefined
   * @private
   * @memberof BlossomComponentTree
   */
  private findBlossomComponentInTree = (
    test: (component: NewBlossomComponent) => boolean
  ): NewBlossomComponent | undefined => {
    const search = (components: NewBlossomComponent[]): NewBlossomComponent | undefined => {
      let result: NewBlossomComponent | undefined;

      for (const component of components) {
        if (test(component)) {
          result = component;
          break;
        }

        if (component.hasChildren()) {
          result = search(component.children!);

          if (result) {
            break;
          }
        }
      }

      return result;
    };

    return search(this.tree);
  };
}
